import { MENU_OPEN, MENU_CLOSE } from '../actions/menu';

const initialState = {
    open: false
};

export default function menu(state = initialState, action) {
    switch (action.type) {
        case MENU_OPEN:
            return {
                ...state,
                open: true
            };
        case MENU_CLOSE:
            return {
                ...state,
                open: false
            };
        default:
            return state;
    }
}
